/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import Vue from 'vue'
import Vuex from 'vuex'
import { convertStripeDate } from '@/model/dataLayer/api/common/DateRepository'
import { loadProducts } from '@/model/dataLayer/api/SaaS/product'
import dayjs from 'dayjs'
import IKUtils from 'innerken-js-utils'
import { getAllStoreIdForUser } from '@/model/dataLayer/api/SaaS/subscriptionService'

Vue.use(Vuex)

function calculateLicenseCount (licenseArr) {
  return licenseArr.reduce((t, i) => t + i.deviceCount, 0)
}

export async function formatLicenseData (licenseArr) {
  const products = await loadProducts()
  const unBaseProduct = (await loadProducts()).filter(it => !it.metadata?.base)
  return licenseArr.map(l => {
    const payType = dayjs(l.current_period_end).diff(l.current_period_start, 'month') === 1 ? 'month' : 'year'
    const activePricesIds = l.prices.map(p => p.product)
    const activeProduct = products.filter(p => activePricesIds.includes(p.id))
    const q = activeProduct.find(a => a.metadata.deviceCountPerUnit)
    l.deviceCount = (parseInt(q?.metadata?.deviceCountPerUnit ?? 0)) * l.quantity
    const res = activeProduct.map(a => {
      if (a.metadata.overWrite === 'addDevice') {
        a.quantity = l.quantity
      } else {
        a.quantity = 1
      }
      const res = (a?.metadata?.overWrite ?? '').split(';')
      const mainProductsName = []
      unBaseProduct.forEach(x => {
        if (res.includes(x.metadata.overWrite)) {
          mainProductsName.push(x.name)
        }
      })
      a.mainProductsName = res
      a.mainProducts = mainProductsName
      a.subscriptionID = l.id
      a.payTypePrice = a.prices.find(b => b.interval === payType)
      a.payType = payType
      a.totalPrice = a.payTypePrice.unit_amount / 100
      return a
    })
    l.productInfo = IKUtils.deepCopy(res)
    l.date = convertStripeDate(l.created)
    return l
  })
}

export default new Vuex.Store({
  state: {
    // url: 'localhost',
    loginStateReady: false,
    license: [],
    showErrorDialog: false,
    errorDialogTitle: '',
    errorDialogMessage: '',
    showBillDetailDialog: false,
    billDetailId: null,
    showProductDetailDialog: false,
    activeProductCode: null,
    SaaSGuide: 0,
    showErrorDishDialog: false,
    errorDishDialogMessage: '',
    errorDishDialogTitle: '',
    errorDishList: [],
    errorTypeImport: '',
    showProductPage: false,
    productPageUrl: '',
    SaaSCallback: null,
    showWaitPaymentDialog: false,
    showInternetErrorDialog: false,
    errorInternetDialogTitle: '',
    showLoading: false,
    loadingType: '',
    currencySymbols: '',
    storeOwnedLicense: [],
    adminMode: ''
  },
  mutations: {
    adminMode (state, mode) {
      state.adminMode = mode
    },
    currencySymbols (state, symbols) {
      state.currencySymbols = symbols
    },
    showLoading (state, type) {
      state.showLoading = true
      state.loadingType = type
    },
    hideLoading (state) {
      state.loadingType = ''
      state.showLoading = false
    },
    showWaitPaymentDialog (state) {
      state.showWaitPaymentDialog = true
    },
    hideWaitPaymentDialog (state) {
      state.showWaitPaymentDialog = false
    },
    async updateLicense (state, licenseArr) {
      state.license = licenseArr
    },
    refreshLicense (state) {
      state.license = [...state.license]
    },
    loginStateReady (state) {
      state.loginStateReady = true
    },
    showProductDetail (state, payload) {
      state.SaaSCallback = payload.callback
      state.SaaSGuide = payload.SaaSGuide
      state.activeProductCode = payload.code
      state.showProductDetailDialog = true
    },
    closeProductDetail (state) {
      state.showProductDetailDialog = false
      state.activeProductCode = null
    },
    showBillDetail (state, id) {
      state.billDetailId = id
      state.showBillDetailDialog = true
    },
    closeBillDetail (state) {
      state.showBillDetailDialog = false
      state.billDetailId = null
    },
    showErrorDialog (state, title, message = '') {
      console.log(title)
      state.showErrorDialog = true
      state.errorDialogMessage = message
      state.errorDialogTitle = title
    },
    closeErrorDialog (state) {
      state.showErrorDialog = false
    },
    showInternetErrorDialog (state) {
      state.showInternetErrorDialog = true
    },
    closeInternetErrorDialog (state) {
      state.showInternetErrorDialog = false
    },
    showProductPage (state, link) {
      state.productPageUrl = link
      state.showProductPage = true
    },
    closeProductPage (state) {
      state.showProductPage = false
    },
    showErrorDishDialog (state, payload) {
      state.showErrorDishDialog = true
      state.errorTypeImport = payload.value
      if (payload.value === 'dish') {
        state.errorDishDialogMessage = payload.message.map(it => it.code).join()
        state.errorDishDialogTitle = payload.title
        state.errorDishList = payload.message
      } else {
        state.errorDishDialogMessage = payload.message.map(it => it.printMod).join()
        state.errorDishDialogTitle = payload.title
        state.errorDishList = payload.message
      }
    },
    closeErrorDishDialog (state) {
      state.showErrorDishDialog = false
    },

    updateStoreOwnedLicense (state, newArr) {
      state.storeOwnedLicense = newArr.filter(l => l.status === 'active')
    }

  },
  actions: {},
  getters: {
    totalLicenseCount (state) {
      return calculateLicenseCount(state.license)
    },
    async availableLicenseCount (state) {
      return calculateLicenseCount(state.license) - (await getAllStoreIdForUser()).length
    }
  }
})
